import { ColumnSelectionsModel } from "../../models";

export const CallCenterStatusColumns: ColumnSelectionsModel[] = [
    { name: 'Name', propertyName: 'Name', isEnabled: true },
    { name: 'Email', propertyName: 'Email', isEnabled: true },
    { name: 'Platform Type', propertyName: 'PlatformType', isEnabled: false },
    { name: 'Status', propertyName: 'Status', isEnabled: true },
    { name: 'Call ID', propertyName: 'CallId', isEnabled: false },
    { name: 'Device', propertyName: 'Device', isEnabled: false },
    { name: 'Start Time', propertyName: 'StartTime', isEnabled: true },
    { name: 'End Time', propertyName: 'EndTime', isEnabled: true },
    { name: 'Interval', propertyName: 'IntervalTime', isEnabled: true },
    // { name: 'Details', propertyName: 'Details', isEnabled: false },
]